import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { matchPath } from 'react-router'
import classnames from 'classnames'
import _ from 'lodash'

const themes = {
  default: null
}

const tab = (index, route, { content, active, ...rest }) => {
  let isCurrentPath;

  if (active === null || active === undefined) {
    const { location } = route
    const { to } = rest

    isCurrentPath = !!matchPath(location.pathname, { path: to, exact: true })
  }
  else { isCurrentPath = active }

  const classes = classnames("tabs__block-item", {
    "tabs__block-item--active": !!isCurrentPath
  })

  const caption = content === 'function' ? content() : content

  return (
    <Link key={index} className={classes} {...rest}>
      <div className="tabs__text-wrapper" title={caption}>
        { caption }
      </div>
    </Link>
  )
}

const Tabs = ({ theme, route, items, className }) => {
  const enabledItems = _.filter(items, (item) => {
    return !!_.defaultTo(item.disabled, false) == false
  })

  return (
    <div className={classnames("tabs", themes[theme], className)}>
      <div className="tabs__block">
        { _.map(enabledItems, (item, index) => tab(index, route, item)) }
      </div>
    </div>
  )
}

Tabs.propTypes = {
  items: PropTypes.array.isRequired,
  route: PropTypes.object
}

Tabs.defaultProps = {
  theme: "default"
}

export default Tabs
